import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "styling"
    }}>{`Styling`}</h1>
    <p>{`You can change the style easily by overriding the css or supply your own base components, or just override all the field components`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import './your-own.css'
import './TextInput'


const fields = {
  text: TextInput,
  // ... other components
}

export const App = () => {
  return <ReformlProvider fieldComponents={fields}>
  {/* All reforml forms in this will use your custom components */}
  </ReformlProvider>
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      